import { PaddingSize, Percentage } from '@styleseat/ui';

// Legacy images
export { default as DeprecatedBarberImage } from './images/barber_hp_tile.png';
export { default as DeprecatedFacialImage } from './images/facial_hp_tile.png';
export { default as DeprecatedMakeupImage } from './images/makeup_hp_tile.png';
export { default as DeprecatedVirtualImage } from './images/virtual_hp_tile.png';

// Updated images
export { default as DeprecatedBraidsImage } from './images/braids_2021_hp_tile.png';
export { default as DeprecatedEyelashesImage } from './images/eyelashes_2021_hp_tile.png';
export { default as DeprecatedHaircutImage } from './images/haircut_2021_hp_tile.png';
export { default as DeprecatedKidsImage } from './images/kids-haircuts.png';
export { default as DeprecatedLocsImage } from './images/locs_2021_hp_tile.png';
export { default as DeprecatedMensHaircutImage } from './images/mens_haircut_2021_hp_tile.png';
export { default as DeprecatedNailsImage } from './images/nails_2021_hp_tile.png';
export { default as DeprecatedNaturalHairImage } from './images/natural_hair_2021_hp_tile.png';
export { default as DeprecatedSilkPressImage } from './images/silk_press_2021_hp_tile.png';
export { default as DeprecatedWeavesImage } from './images/weaves_2021_hp_tile.png';

export { default as DeprecatedWigsImage } from './images/wigs_tile.png';
export { default as DeprecatedUpdatedMakeupImage } from './images/makeup_tile.png';
export { default as DeprecatedEyebrowsImage } from './images/eyebrows_tile.png';
export { default as DeprecatedPedicureImage } from './images/pedicure_tile.png';
export { default as DeprecatedWaxImage } from './images/wax_tile.png';

// 2024 images
const BaseImagesUrl = 'https://www.styleseat.com/bundles/static/assets/home/landing_page';
export const BraidsImage = { uri: `${BaseImagesUrl}/braids_tile.jpg` };
export const BraidsImageMobile = { uri: `${BaseImagesUrl}/mobile_braids_tile.jpg` };
export const EyeLashesImageMobile = { uri: `${BaseImagesUrl}/mobile_eyelashes_tile.jpg` };
export const HaircutImageMobile = { uri: `${BaseImagesUrl}/mobile_haircut_tile.jpg` };
export const LocsImageMobile = { uri: `${BaseImagesUrl}/mobile_locs_tile.jpg` };
export const MensHaircutImageMobile = { uri: `${BaseImagesUrl}/mobile_mens_haircut_tile.jpg` };
export const NailsImageMobile = { uri: `${BaseImagesUrl}/mobile_nails_tile.jpg` };
export const NaturalHairImageMobile = { uri: `${BaseImagesUrl}/mobile_natural_hair_tile.jpg` };
export const SilkPressImageMobile = { uri: `${BaseImagesUrl}/mobile_silk_press_tile.jpg` };
export const WeavesImageMobile = { uri: `${BaseImagesUrl}/mobile_weaves_tile.jpg` };
export const ColorsImage = { uri: `${BaseImagesUrl}/color_tile.jpg` };
export const EyeLashesImage = { uri: `${BaseImagesUrl}/eyelashes_tile.jpg` };
export const HaircutImage = { uri: `${BaseImagesUrl}/haircut_tile.jpg` };
export const KidsImage = { uri: `${BaseImagesUrl}/kids_tile.jpg` };
export const LocsImage = { uri: `${BaseImagesUrl}/locs_tile.jpg` };
export const MakeupImage = { uri: `${BaseImagesUrl}/makeup_tile.jpg` };
export const MensHaircutImage = { uri: `${BaseImagesUrl}/mens_haircut_tile.jpg` };
export const NailsImage = { uri: `${BaseImagesUrl}/nails_tile.jpg` };
export const NaturalHairImage = { uri: `${BaseImagesUrl}/natural_hair_tile.jpg` };
export const SilkPressImage = { uri: `${BaseImagesUrl}/silk_press_tile.jpg` };
export const WeavesImage = { uri: `${BaseImagesUrl}/weaves_tile.jpg` };

export enum TilesSizes {
  Desktop = 'desktop',
  Tablet = 'tablet',
  TabletNarrow = 'tablet-narrow',
  TabletSmall = 'tablet-small',
  Phone = 'phone',
  PhoneLarge = 'phone-large',
  PhoneExtraLarge = 'phone-extra-large',
}

export type TilesConfig = {
  imageHeight: number;
  imageWidth: number;
  space: PaddingSize;
  tileWidth: Percentage;
};

export const TilesSizesMap: { [key in TilesSizes]: TilesConfig } = {
  [TilesSizes.Desktop]: {
    imageHeight: 126,
    imageWidth: 200,
    space: 28,
    tileWidth: '15%',
  },
  [TilesSizes.Phone]: {
    imageHeight: 70,
    imageWidth: 100,
    space: 12,
    tileWidth: '15%',
  },
  [TilesSizes.PhoneLarge]: {
    imageHeight: 84,
    imageWidth: 120,
    space: 12,
    tileWidth: '15%',
  },
  [TilesSizes.PhoneExtraLarge]: {
    imageHeight: 98,
    imageWidth: 141,
    space: 16,
    tileWidth: '15%',
  },
  [TilesSizes.TabletSmall]: {
    imageHeight: 68,
    imageWidth: 92,
    space: 16,
    tileWidth: '32%',
  },
  [TilesSizes.TabletNarrow]: {
    imageHeight: 84,
    imageWidth: 120,
    space: 12,
    tileWidth: '19%',
  },
  [TilesSizes.Tablet]: {
    imageHeight: 98,
    imageWidth: 141,
    space: 16,
    tileWidth: '15%',
  },
};
